module.exports = __webpack_public_path__ + "static/media/s_ski_jump.d98b4030.mp3";